'use strict';

angular.module('ClinicApp').factory('AppointmentService', function($http, ClinicConfig, AppointmentStateResource, AppointmentResource, OpencareConstants) {
  return {
    cancelAppointment: function(appointmentId, params) {
      return AppointmentStateResource.cancel({
        id: appointmentId,
      }, params).$promise;
    },

    addNote: function(appointmentId, note) {
      return AppointmentStateResource.note({
        id: appointmentId,
      }, {
        note: note,
      }).$promise;
    },

    updateAppointment: function(
      appointmentId,
      date,
      startTime,
      providerId,
      duration,
      offeredAppointmentTypeId,
      note,
      patientContactMethod,
    ) {
      return AppointmentStateResource.update({
        id: appointmentId,
      }, {
        date: date,
        startTime: startTime,
        duration: duration,
        providerId: providerId,
        offeredAppointmentType: offeredAppointmentTypeId,
        note: note,
        patientContactMethod: patientContactMethod,
      }).$promise;
    },

    verifyAppointment: function(appointmentId, data) {
      return $http.post(ClinicConfig.HOSTNAME + '/clinic/appointment/' + appointmentId + '/verify', data, {
        withCredentials: true,
      }).then(function(response) {
        return response.data;
      });
    },

    // Resets appointment datetime and moves it to the REQUESTED state.
    resetAppointment: function(appointmentId) {
      return AppointmentStateResource.update({
        id: appointmentId,
      }, {}).$promise;
    },

    listAppointments: function(modelType, modelId, patientSearchQuery, limit) {
      modelType = (modelType || '').toLowerCase();
      return $http.get(ClinicConfig.HOSTNAME + '/' + modelType + '/' + modelId + '/appointments', {
        params: {
          patientSearch: patientSearchQuery,
          limit: limit,
        },
      }).then(function(response) {
        return response.data;
      });
    },

    hasAppointments: function(modelType, modelId) {
      return this.listAppointments(modelType, modelId, null, 1).then(function(appointments) {
        return !_.isEmpty(appointments);
      });
    },

    listAppointmentsForOrganizer: function(modelType, modelId, organizerTabName, page, rpp) {
      var appointmentType = organizerTabName == 'requests' ? 'requested' : organizerTabName;
      return $http.get(ClinicConfig.HOSTNAME + '/' + modelType + '/' + modelId + '/appointments/' + appointmentType, {
        params: {
          page: page,
          resultsPerPage: rpp || 0,
          getOverdueNPRs: organizerTabName == 'requests' ? true : false,
        },
      }).then(function(response) {
        return response.data;
      });
    },

    listAppointmentsForCalendar: function(modelType, modelId, from, to) {
      return $http.get(ClinicConfig.HOSTNAME + '/' + modelType + '/' + modelId + '/appointments/calendar', {
        params: {
          from: moment.isMoment(from) ? from.format('YYYY-MM-DD') : from,
          to: moment.isMoment(to) ? to.format('YYYY-MM-DD') : to,
        },
      }).then(function(response) {
        return response.data;
      });
    },

    listAppointmentsForTimeSlot: function(modelType, modelId, filters, clinicId) {
      return $http.get(ClinicConfig.HOSTNAME + '/' + modelType + '/' + modelId + '/appointments/timeslot', {
        params: {
          dateGte: filters.dateGte,
          dateLt: filters.dateLt,
          clinic: clinicId,
        },
      }).then(function(response) {
        return response.data;
      });
    },

    getAppointment: function(appointmentId) {
      return AppointmentResource.get({
        id: appointmentId,
      }).$promise;
    },

    sendMessage: function(appointmentId, message) {
      return AppointmentStateResource.message({
        id: appointmentId,
      }, {
        message: message,
      }).$promise;
    },

    viewed: function(appointmentId) {
      return AppointmentStateResource.viewed({
        id: appointmentId,
      }).$promise;
    },

    getSlotWorks: function(appointmentId) {
      return AppointmentStateResource.getSlotWorks({
        id: appointmentId,
      }).$promise;
    },

    getHistory: function(appointmentId) {
      return AppointmentStateResource.getHistory({
        id: appointmentId,
      }).$promise;
    },

    updateBillingContested: function(appointmentId, billingContested, billingContestedReason) {
      return AppointmentStateResource.billingContested({
        id: appointmentId,
      }, {
        billingContested: billingContested,
        billingContestedReason: billingContestedReason,
      }).$promise;
    },

    defer: function(appointmentId) {
      return AppointmentStateResource.defer({
        id: appointmentId,
      }).$promise;
    },

    isAutomaticallyVerified: function(appointment) {
      return appointment.history?.some((history) => {
        const isVerified = {
          [OpencareConstants.appointmentHistory.actionTypes.APPT_RECONCILLED]: () => true,
          [OpencareConstants.appointmentHistory.actionTypes.STATUS]: () => history?.metadata?.adminVerified,
        }[history.actionType];
        return Boolean(isVerified?.());
      });
    },
  };
});
